import React from 'react';
import Box from '@mui/material/Box';

import { SalonPublicThemeProvider } from '../../../context/SalonPublicThemeContext';
import { DEFAULT_SALON_PUBLIC_LAYOUT } from '../../../theme/salonPublicLayout';
import SalonPublicButton from '../salonPublicAppearance/SalonPublicButton';


const SalonButtonStyleSample = ({
  buttons,
  label,
  theme,
  direction = 'ltr',
}) => (
  <SalonPublicThemeProvider
    config={theme}
    layoutConfig={{
      ...DEFAULT_SALON_PUBLIC_LAYOUT,
      buttons: {
        ...DEFAULT_SALON_PUBLIC_LAYOUT.buttons,
        ...buttons,
      },
    }}
    direction={direction}
  >
    <Box sx={{ display: 'flex', justifyContent: 'center', py: 0.5 }}>
      <SalonPublicButton
        component="span"
        data-testid="salon-button-style-sample"
        aria-hidden="true"
        tabIndex={-1}
        sx={{ pointerEvents: 'none', maxWidth: '100%' }}
      >
        {label}
      </SalonPublicButton>
    </Box>
  </SalonPublicThemeProvider>
);

export default SalonButtonStyleSample;
